import { formatNumberToPrice } from "../../../../../helpers/priceFormatting";
import styles from "../QuoteForm.module.scss";

interface QuoteTotalsSectionProps {
  shipping: number;
  onShippingChange: (value: number) => void;
  others: number;
  onOthersChange: (value: number) => void;
  subtotal: number;
  discountTotal: number;
  vat19: number;
  total: number;
}

export function QuoteTotalsSection({
  shipping,
  onShippingChange,
  others,
  onOthersChange,
  subtotal,
  discountTotal,
  vat19,
  total,
}: QuoteTotalsSectionProps) {
  return (
    <div className={styles.totalsSection}>
      <div className={styles.totalRow}>
        <span className={styles.totalLabel}>Valor de despacho</span>
        <div className={styles.totalInputGroup}>
          <span className={styles.currencyPrefix}>$</span>
          <input
            type="number"
            min="0"
            step="1"
            value={shipping ?? 0}
            onChange={(e) => onShippingChange(parseFloat(e.target.value) || 0)}
            className={styles.totalInput}
          />
        </div>
      </div>
      <div className={styles.totalRow}>
        <span className={styles.totalLabel}>Otros</span>
        <div className={styles.totalInputGroup}>
          <span className={styles.currencyPrefix}>$</span>
          <input
            type="number"
            min="0"
            step="1"
            value={others ?? 0}
            onChange={(e) => onOthersChange(parseFloat(e.target.value) || 0)}
            className={styles.totalInput}
          />
        </div>
      </div>
      <div className={styles.totalRow}>
        <span className={styles.totalLabel}>Subtotal</span>
        <span className={styles.totalValue}>
          {formatNumberToPrice(subtotal)}
        </span>
      </div>
      {discountTotal ? (
        <div className={styles.totalRow}>
          <span className={styles.totalLabel}>Descuentos</span>
          <span className={styles.totalValue}>
            -{formatNumberToPrice(discountTotal)}
          </span>
        </div>
      ) : null}
      <div className={styles.totalRow}>
        <span className={styles.totalLabel}>IVA 19%</span>
        <span className={styles.totalValue}>{formatNumberToPrice(vat19)}</span>
      </div>
      <div className={`${styles.totalRow} ${styles.finalTotal}`}>
        <span className={styles.totalLabel}>Total</span>
        <span className={styles.totalValue}>{formatNumberToPrice(total)}</span>
      </div>
    </div>
  );
}
